module.exports = __webpack_public_path__ + "static/media/loupsGarous_01_thumb.9759b52c.png";